'use client';
import { Drawer } from '@/components/common/Drawer';
import { SvgComment } from '@/components/common/Icons/Comment';
import { CommentPanel } from '@/features/comments';
import { createContext, useCallback, useMemo, useState } from 'react';

interface CommentContextType {
	onOpen: (conversationId: string) => void;
	onClose: () => void;
}

export const CommentContext = createContext<CommentContextType>({
	onOpen: () => {},
	onClose: () => {},
});

export function CommentProvider({
	children,
}: { readonly children: React.ReactNode }) {
	const [isOpen, setIsOpen] = useState(false);
	const [conversationId, setConversationId] = useState<string>('');

	const onOpen = useCallback((conversationId: string) => {
		setIsOpen(true);
		setConversationId(conversationId);
	}, []);
	const onClose = useCallback(() => {
		setIsOpen(false);
		setConversationId('');
	}, []);

	const value = useMemo(
		() => ({
			onOpen,
			onClose,
		}),
		[onOpen, onClose],
	);

	const title = (
		<div className="flex items-center gap-2">
			<SvgComment />
			<p className="text-sm text-grey-1">Comments</p>
		</div>
	);

	return (
		<CommentContext.Provider value={value}>
			{children}
			<Drawer open={isOpen} onClose={onClose} title={title}>
				<CommentPanel conversationId={conversationId} />
			</Drawer>
		</CommentContext.Provider>
	);
}
